/**
 * Validação client-side da nova senha (recuperação de senha da equipe — mesmo
 * par de campos que o primeiro acesso: senha + confirmar). Mesma regra do
 * backend (`senhaSchema` em `packages/shared`) — mín. 8 caracteres — mais a
 * conferência de que os dois campos coincidem, que só faz sentido no cliente.
 */
export function validarNovaSenha(senha: string, confirma: string): string | null {
  if (senha.length < 8) return 'A senha precisa de pelo menos 8 caracteres.';
  if (senha !== confirma) return 'As senhas não são iguais.';
  return null;
}
